import Vue from "vue";
import vuetify from "./plugins/vuetify";
import Vuetify from "vuetify";
import App from "./App.vue";
import router from "./router";
import { store } from "./store.js";
import VueToastr from "@deveodk/vue-toastr";
import "@deveodk/vue-toastr/dist/@deveodk/vue-toastr.css";

import "@fortawesome/fontawesome-pro/css/fontawesome.min.css";
import "@fortawesome/fontawesome-pro/css/light.min.css";
import { firestorePlugin } from "vuefire";

Vue.use(firestorePlugin);
// use plugin
Vue.use(VueToastr, {
  defaultPosition: "toast-top-right",
});

Vue.use(Vuetify, {
  theme: {
    primary: "#3367d6",
    secondary: "#b0bec5",
    accent: "#f50057",
    error: "#b71c1c",
  },
});
const fb = require("./firebaseConfig.js");
Vue.config.productionTip = false;
fb.auth.onAuthStateChanged((user) => {
  if (
    user &&
    (router.history.current.path == "/login" ||
      router.history.current.path == "/")
  ) {
    let hash = window.location.hash.replace("#", "");
    if (hash == "/login") hash = "/dashboard";
    router.push(hash);
    return;
  }
  if (!user && router.history.current.path != "/login") {
    router.push("/login");
  }
});

new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
